import { defineMessages } from 'react-intl';

import { Switch } from 'atoms/inputs/Switch';
import { useCurrentUserContext } from 'contexts/currentUser';
import { LIFECYCLE, useLifecycle } from 'hooks/useLifecycle';
import { fantasy } from 'lib/glossary';

import { SettingsSection } from '../SettingsSection';

const messages = defineMessages({
  description: {
    id: 'Settings.conversionCredit.description',
    defaultMessage: 'Apply market credits by default when buying cards.',
  },
});

export const DisableConversionCreditPreselection = () => {
  const { currentUser } = useCurrentUserContext();
  const { update, lifecycle } = useLifecycle();
  const unselect =
    lifecycle?.unselectConversionCreditByDefaultFromSettings || false;

  if (!currentUser) return null;

  return (
    <SettingsSection
      title={fantasy.credits}
      description={messages.description}
      toggleButton={
        <Switch
          checked={!unselect}
          onChange={() => {
            update(
              LIFECYCLE.unselectConversionCreditByDefaultFromSettings,
              !unselect
            );
          }}
        />
      }
    />
  );
};
